<sita-global-loader *ngIf="loadingSpinner$ | async" ></sita-global-loader>
<router-outlet />
